import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { Owner } from 'src/app/interfaces/models/owner';

import { BaseModel } from './base-model';
import { ClientRegisteredVendor } from './client-registered-vendor';
import { ExemptVendor } from './exempt-vendor';
import { Vendor } from './vendor';

export class TinCheckReport extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static TinCheckReportProperties: (
    | {
        property: keyof TinCheckReport;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof TinCheckReport;
        type: 'alias';
      }
    | {
        property: keyof TinCheckReport;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    { property: 'requestType', type: 'column', dataType: 'string' },
    { property: 'requestData', type: 'column', dataType: 'JSON' },
    { property: 'responseData', type: 'column', dataType: 'JSON' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    {
      property: 'ClientRegisteredVendor',
      model: 'ClientRegisteredVendor',
      type: 'association'
    },
    { property: 'ExemptVendor', model: 'ExemptVendor', type: 'association' }
  ];

  static {
    TinCheckReport.TinCheckReportProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        TinCheckReport.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        TinCheckReport.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        TinCheckReport.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(TinCheckReportObject: Partial<TinCheckReport>) {
    super();

    TinCheckReport.TinCheckReportProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = TinCheckReportObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  VendorId?: number | null;
  ClientRegisteredVendorId?: number | null;
  ExemptVendorId?: number | null;
  requestType?: 'Tin Match';
  requestData?: JSON;
  responseData?: JSON;
  createdAt?: Date;
  updatedAt?: Date;

  Vendor?: Vendor;
  ClientRegisteredVendor?: ClientRegisteredVendor;
  ExemptVendor?: ExemptVendor;
}
